import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Unveil } from '@homeaway/react-unveil';
import { fetchRecommendedProperties } from '../../redux/modules/recommendedProperties';

import AsyncRecommendedProperties from './AsyncRecommendedProperties';

class ConnectedRecommendedProperties extends Component {
  componentDidMount() {
    this.props.fetchRecommendedProperties({ limit: this.props.limit });
  }

  render() {
    const { data, title, subtitle, lbsId } = this.props;

    return data.length >= 5 ? (
      <Unveil>
        <AsyncRecommendedProperties {...{ data, title, subtitle, lbsId }} />
      </Unveil>
    ) : null;
  }
}

const mapStateToProps = ({ recommendedProperties }) => ({
  ...recommendedProperties
});

const mapDispatchToProps = {
  fetchRecommendedProperties
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedRecommendedProperties);